<template>
  <div>
    <div class="risk-phone" v-if="this.$store.state.productLoading">
      <not-available v-if="getList.length === 0" title="手机号画像">
        <div class="product-introduce">
          <p
            class="bottom"
          >手机号是当前互联网业务中非常重要的身份验证要素，也是黑产与厂商对抗的核心资源。黑产使用的手机卡（手机黑卡）从收购、销售，到使用（活动欺诈）、回收，已经发展为一条完整的产业链。</p>
          <p>
            <span class="product">手机号画像</span>基于威胁猎人的蜜罐网络流量监测及行业数据共享，帮助企业精准识别异常账号和恶意注册行为。
          </p>
          <p>产品优势：1亿+风险手机号标签数据，每日10-20万新增数据；覆盖全球手机号，其中海外手机号码总量4000万+</p>
          <p>更新频率：支持分钟级更新</p>
          <p>交付方式：SaaS API或私有化部署</p>
        </div>
      </not-available>
      <div class="risk-phone-wrap" v-if="getList.length > 0">
        <div class="risk-phone-header">
          <h3 v-if="getList.length === 1">{{selectName}}</h3>
          <div class="select active" v-if="getList.length>1">
            <span @click="selectProduct">
              {{selectName}}
              <i class="iconfont iconsanjiaoxingbeifen" :class="{active:show}"></i>
            </span>
            <ul class="select-list" v-if="show">
              <li
                :class="{active:type ===item.value}"
                v-for="(item,index) in getList"
                :key="index"
                @click="selectItem(item.value)"
              >{{item.label}}</li>
            </ul>
          </div>
          <a v-if="selectUrl" :href="selectUrl" target="_blank">
            <i class="iconfont iconkzt_jswd1"></i>
            技术文档
          </a>
        </div>
        <component
          :is="getComponent"
          :key="type"
          v-bind="getComponentProps"
        ></component>
      </div>
    </div>
    <loading v-if="!this.$store.state.productLoading"></loading>
  </div>
</template>

<script>
import notAvailable from '../../components/mark/notAvailable'
import riskPhoneOnline from './components/riskPhoneOnline'
import riskPhoneOffline from './components/riskPhoneOffline'
import { DOCUMENT_CENTER } from '@/config.js'
import { getPhoneOverseasUpdatePackageData } from '@/services/interface'
export default {
  components: { riskPhoneOnline, riskPhoneOffline, notAvailable },
  data () {
    return {
      show: false,
      type: null,
      list: [
        {
          label: '手机号画像-在线API版本',
          value: 'heika_online',
          url: DOCUMENT_CENTER + '/riskphone/api2.0.html',
          component: 'riskPhoneOnline'
        },
        {
          label: '手机号画像-私有化版本',
          value: 'heika_offline',
          url: DOCUMENT_CENTER + '/riskphone/private-api.html',
          component: 'riskPhoneOffline'
        },
        {
          label: '境外手机号画像-私有化版本',
          value: 'heika_without_mainland_offline',
          url: '',
          component: 'riskPhoneOffline',
          componentProps: {
            title: '境外手机号画像-私有化版本',
            productCode: 'heika_without_mainland_offline',
            updatePackageRequest: getPhoneOverseasUpdatePackageData,
            updatePackageVersion: '',
            showDocumentGuide: false
          }
        }
      ]
    }
  },
  computed: {
    getList () {
      return this.list.filter(item => {
        return this.$store.state.product.some(product => {
          return product.busi === item.value && product.auditflag === '5'
        })
      })
    },
    selectedItem () {
      return this.getList.find(item => item.value === this.type)
    },
    selectName () {
      return this.selectedItem ? this.selectedItem.label : ''
    },
    selectUrl () {
      return this.selectedItem ? this.selectedItem.url : ''
    },
    getComponent () {
      return this.selectedItem ? this.selectedItem.component : null
    },
    getComponentProps () {
      return this.selectedItem ? this.selectedItem.componentProps || {} : {}
    }
  },
  watch: {
    getList: {
      immediate: true,
      handler () {
        this.syncSelectedType(this.$route.params.busi)
      }
    },
    '$route.params.busi' (type) {
      this.syncSelectedType(type)
    }
  },
  methods: {
    syncSelectedType (type) {
      const hasRouteType = type && this.getList.some(item => item.value === type)
      if (hasRouteType) {
        this.type = type
      } else if (!this.getList.some(item => item.value === this.type)) {
        this.type = this.getList.length > 0 ? this.getList[0].value : null
      }
    },
    selectProduct () {
      this.show = !this.show
    },
    selectItem (type) {
      this.type = type
      this.show = false
    }
  }
}
</script>

<style lang="scss">
.risk-phone {
  padding: 30px 40px;

  .risk-phone-wrap {
    .risk-phone-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;
      h3 {
        font-size: 18px;
        font-weight: 500;
        color: rgba(29, 36, 60, 1);
        line-height: 30px;
      }
      .select {
        position: relative;
        font-size: 18px;
        font-weight: 500;
        color: rgba(29, 36, 60, 1);
        line-height: 30px;

        > span {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
        }

        &.active {
          cursor: pointer;
        }

        i {
          display: inline-block;
          transform: rotate(90deg);
          margin-left: 8px;

          &.active {
            transform: rotate(270deg);
          }
        }

        .select-list {
          position: absolute;
          top: 38px;
          left: 0;
          z-index: 99;
          width: max-content;
          min-width: 100%;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 4px 8px 0 rgba(17, 39, 98, 0.04);
          padding: 12px 0;

          li {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(29, 36, 60, 1);
            text-align: left;
            white-space: nowrap;
            padding: 0 20px;
            box-sizing: border-box;
            &:hover {
              background: rgba(220, 234, 255, 1);
            }

            &.active {
              background: rgba(220, 234, 255, 1);
            }
          }
        }
      }

      a {
        width: 92px;
        height: 32px;
        background: rgba(0, 61, 146, 1);
        border-radius: 4px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        i {
          position: relative;
          top: 1px;
        }
      }
    }
  }
}
</style>
